import { TimeRange } from "hooks/usePrecachedHeats";
import { createContext, use } from "react";

export const HEATS_PREFETCH_COUNT = 3;

export type ViewMode = "day" | "shift";

// --- Time Range Context (common to both modes) ---

export interface HeatsTimeRangeContextType {
  viewMode: ViewMode;
  timeRange: TimeRange;
  day?: string;
  prefetchRanges: TimeRange[];
  filterMode: "overlap" | "fully_contained";
  isLoading: boolean;
  isError: boolean;
}

export const HeatsTimeRangeContext = createContext<
  HeatsTimeRangeContextType | undefined
>(undefined);

export const useHeatsTimeRange = (): HeatsTimeRangeContextType => {
  const context = use(HeatsTimeRangeContext);
  if (context === undefined) {
    throw new Error(
      "useHeatsTimeRange must be used within a HeatsNavigationProvider"
    );
  }
  return context;
};
